import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import BackArrow from './BackArrow';

const CustomBackHeader = ({
    title = "",
    backArrowIconComponent = null,
    rightComponent,
    isTransperent = false,
    customClass = "",
    isSticky = false,
    backBtnRef,
    // Overrides the default bg-white/bg-transparent + border classes below
    // when a caller needs a background that isn't plain white or fully
    // transparent (e.g. a solid brand color) — pass "" to drop the default
    // border along with it. Falls back to the original isTransperent-driven
    // classes when omitted, so existing callers are unaffected.
    bgClass,
    // Recolors the built-in arrow icon (default preserves the existing
    // `.menu-head` styling). Pass a plain color utility like "text-white"
    // for a header whose background isn't light, instead of having to hand
    // in a whole custom backArrowIconComponent just to change its color.
    arrowColorClass = "menu-head",
}) => {
    const navigate = useNavigate();
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
    const clientMasterData = useSelector((state) => state.clientMasterReducer);
    const clientData = clientMasterData?.clientMasterData || [];
    const emptySpaceHolder = <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>;

    const handleResize = () => {
        setIsMobileView(window.innerWidth <= 769);
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <>{clientData[0]?.isBackButton &&
            <header className={`${isSticky && "fixed z-50"} ${bgClass ?? (isTransperent ? "bg-transparent absolute z-50" : "bg-white border-b-2 border-grey")} w-full p-4 flex items-center justify-content-between ${customClass || ""}`}>
                {isMobileView ? <div className="flex items-center ">
                    {backArrowIconComponent ? backArrowIconComponent : (
                        <BackArrow
                            colorClass={arrowColorClass}
                            onClick={() => {
                                if (backBtnRef) {
                                    backBtnRef.current = true;
                                }
                                navigate(-1);
                            }}
                        />
                    )}
                </div> : emptySpaceHolder}
                <h1 className="font-semibold line-hi banner-carousel">
                    {title || ""}
                </h1>
                {rightComponent ? rightComponent : emptySpaceHolder}
            </header>}
        </>
    )
}

export default CustomBackHeader